/**
 * 注意！会给外部使用 不要轻易引入ku-mega内部依赖
*/
export const getIsSdkPage = () => {
    return !!(window as any).isSdkPage;
};

export const isDocSdkPage = () => {
    return !!(window as any).isDocSdkPage;
};
